import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideo"><Path d="M15.7534 9.87332L21.5 7V17L15.7534 14.1267M2.5 4.5H15.5V19.5H2.5V4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconVideo;
